import { IPackage } from "dto/IPackage";
import { createContext } from "react";

type IPackageThreadContext = {
  threadPackages: IPackage[];
  setThreadPackages: (packages: IPackage[]) => void;
};

const PackageThreadContext = createContext<IPackageThreadContext>({
  threadPackages: [],
  setThreadPackages: () => {},
});

export default PackageThreadContext;
